import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { gamePercentAgent } from 'src/app/apis/agent.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-form-casino',
  templateUrl: './form-casino.component.html',
  styleUrls: ['./form-casino.component.scss']
})
export class FormCasinoComponent implements OnInit {

  @Input() Data: any;
  @Output() DataChange = new EventEmitter();

  prod = environment.production;

  constructor() { }

  ngOnInit() {
  }
  onChangePercent(game_code: string) {
    const game = this.Data.profit_sharing.find((c) => c.game_code === game_code) as gamePercentAgent;
    if (game.percent_own < 0) {
      game.percent_own = 0;
    }
    if (game.percent_own > game.percent_parent) {
      game.percent_own = game.percent_parent;
    }
    game.percent_given = game.percent_parent - game.percent_own;

    if (game.percent_given < 0) {
      game.percent_given = 0;
      game.percent_own = game.percent_parent;
    }

    this.DataChange.emit(this.Data);
  }

  onChangeCasinoBetlimt(limit_name: string, game_code: string) {
    const game = this.Data.profit_sharing.find((c) => c.game_code === game_code);
    game.casino_betlimit.selected = Object.assign(
      {},
      game.casino_betlimit.list.find((c) => c.limit_name === limit_name)
    );
    this.DataChange.emit(this.Data);
  }
}
